// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { escapeForUrl } from 'lib/common';
import './CategorySubItem.scss';

type Props = {
  name: string,
  count: number,
};

const CategorySubItem = ({ name, count }: Props) => (
  <Link className="CategorySubItem" to={`/categories/${escapeForUrl(name)}`}>
    <div className="name">{name}</div>
    <div className="counts">{count}</div>
  </Link>
);

export default CategorySubItem;



// WEBPACK FOOTER //
// ./src/components/categories/CategorySubItem/CategorySubItem.js